export default {
  delivery: "Lieferung {{date}}",
  pickup: "Abholung {{date}}",
  room_service: 'Vor Ort {{date}}',
  table_service: 'Vor Ort {{date}}',
  now: "ASAP",
  unavailable: "Nicht verfügbar",
  today: 'Heute',
  buttons: {
    edit: 'Ändern →',
  },
};
